import jQuery from 'jquery';
import vCard from 'vcards-js';
import {
  saveAs
} from 'file-saver';

/**
 * Add toggle functionality to the Expandable List widget.
 *
 * @export
 */
export default function() {
  const $ = jQuery;

  $(document)
    .on('click', '.download-vcard', function() {
      let authorId = $(this).data('id');
      $.getJSON(`/api/default/authors?$filter=UrlName eq '${authorId}'`, function(data) {
        if (data.value.length) {
          let author = data.value[0];
          let authorVCard = vCard();

          authorVCard.firstName = author.FirstName;
          authorVCard.lastName = author.LastName;
          authorVCard.organization = author.EmployerAffiliation;
          authorVCard.workPhone = author.Phone1;
          authorVCard.cellPhone = author.Phone2;
          authorVCard.email = author.Email;
          authorVCard.title = author.Title;
          authorVCard.note = author.ShortBio;
          authorVCard.socialUrls['linkedin'] = author.LinkedInUrl;
          authorVCard.socialUrls['twitter'] = `https://twitter.com/${author.TwitterHandle}`;

          authorVCard.version = '3.0';

          let blob = new Blob([authorVCard.getFormattedString()], {
            type: 'text/vcard'
          });
          saveAs(blob, 'author.vcf');
        }
      });
    });
}


// WEBPACK FOOTER //
// ./assets/src/js/components/author.js